export const GoogleIcons = () => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_503_3854)">
      <path
        d="M18.4924 10.4064C18.4924 9.73553 18.438 9.24597 18.3202 8.73828H10.6594V11.7663H15.1561C15.0655 12.5188 14.5759 13.652 13.488 14.4135L13.4727 14.5149L15.8949 16.3913L16.0627 16.4081C17.6039 14.9847 18.4924 12.8905 18.4924 10.4064Z"
        fill="currentColor"
      />
      <path
        d="M10.6594 18.3855C12.8624 18.3855 14.7119 17.6602 16.0627 16.4091L13.488 14.4145C12.799 14.895 11.8742 15.2305 10.6594 15.2305C8.50174 15.2305 6.67042 13.8072 6.01761 11.8398L5.92192 11.848L3.4033 13.7972L3.37036 13.8887C4.71211 16.5541 7.46817 18.3855 10.6594 18.3855Z"
        fill="currentColor"
      />
      <path
        d="M6.01756 11.8396C5.84531 11.3319 5.74563 10.7879 5.74563 10.2258C5.74563 9.66369 5.84531 9.11975 6.0085 8.61206L6.00394 8.50394L3.45375 6.52344L3.37031 6.56313C2.81731 7.66919 2.5 8.91125 2.5 10.2258C2.5 11.5404 2.81731 12.7824 3.37031 13.8884L6.01756 11.8396Z"
        fill="currentColor"
      />
      <path
        d="M10.6594 5.22134C12.1916 5.22134 13.225 5.88316 13.8144 6.43622L16.1171 4.18784C14.7029 2.87328 12.8624 2.06641 10.6594 2.06641C7.46817 2.06641 4.71211 3.89772 3.37036 6.56309L6.00855 8.61203C6.67042 6.64472 8.50174 5.22134 10.6594 5.22134Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_503_3854">
        <rect
          width="16"
          height="16.375"
          fill="white"
          transform="translate(2.5 2.06641)"
        />
      </clipPath>
    </defs>
  </svg>
);
